import React, { useState, useEffect } from 'react';

import Appearance from 'styles/Appearance.js';
import Request from 'files/Request.js';
import Sector from 'classes/Sector.js';
import TextField from 'views/TextField.js';
import Views from 'views/Main.js';

const SectorLookupField = ({ containerStyle, icon, insetLabel, onChange, placeholder, prependComponent, type, utils, value }) => {

    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState([]);
    const [selected, setSelected] = useState(false);
    const [text, setText] = useState(null);

    const onClick = async sector => {

        // clear results list, set selected sector, and update text field content
        setResults([]);
        setSelected(sector);
        setText(sector.name);

        // notify subscribers of data change
        if(typeof(onChange) === 'function') {
            onChange(sector);
        }
    }

    const onTextChange = async text => {
        try {

            // prevent moving forward with a search request is no text or insufficient text is present
            setText(text);
            if(!text || text.length < 2) {

                // clear results array and notify subscribers that data has changed
                setResults([]);
                if(typeof(onChange) === 'function') {
                    onChange(null);
                }
                return;
            }

            // submit request to server
            let { sectors } = await Request.get(utils, '/sectors/', {
                limit: 5,
                search_text: text,
                sector_type: type,
                type: 'lookup'
            })
            setLoading(false);
            setResults(sectors.map(sector => Sector.create(sector)));

        } catch(e) {
            setLoading(false);
            utils.alert.show({
                title: 'Oops!',
                message: `There was an issue completing your search. ${e.message || 'An unknown error occurred'}`
            });
        }
    }

    useEffect(() => {
        setSelected(value);
        setText(value ? value.name : '');
    }, [value]);

    return (
        <div style={{
            position: 'relative',
            width: '100%',
            ...containerStyle
        }}>
            <TextField
            autoCapitalize={'sentences'}
            autoComplete={false}
            autoCorrect={false}
            icon={icon}
            insetLabel={insetLabel}
            loading={loading}
            placeholder={placeholder || 'Search by id, name, or director...'}
            prependComponent={prependComponent}
            onChange={onTextChange}
            useDelay={true}
            value={text}
            style={{
                flexGrow: 1,
                ...Appearance.textStyles.title()
            }}/>
            {results.length > 0 && (
                <div style={{
                    ...Appearance.styles.unstyledPanel(),
                    marginBottom: 12,
                    marginTop: 8,
                    overflow: 'hidden',
                    padding: 0,
                    textAlign: 'left'
                }}>
                    {results.map((sector, index) => {
                        return (
                            Views.entry({
                                bottomBorder: index !== results.length - 1,
                                hideIcon: true,
                                key: index,
                                onClick: onClick.bind(this, sector),
                                subTitle: sector.director ? `Directed by ${sector.director.full_name}` : 'Director name not available',
                                title: sector.name,
                            })
                        )
                    })}
                </div>
            )}
        </div>
    )
}
export default SectorLookupField;
